module.exports = __webpack_public_path__ + "img/petdog3.427216df.jpg";